import ZoneInputText from './InputContent/ZoneInputText';
import ZoneInputImage from './InputContent/ZoneInputImage';
import { InputContentType } from '../../api/static/zones';
/**
 * @enum
 * @readonly
 */
const ComponentMap = Object.freeze({
  [InputContentType.TEXT]: ZoneInputText,
  [InputContentType.FILE]: ZoneInputImage,
});

export default {
  name: 'InputContentFactory',
  functional: true,
  props: {
    type: {
      type: String,
      default: InputContentType.TEXT,
      validator(v) {
        return Object.values(InputContentType).includes(v);
      },
    },
  },
  render(h, context) {
    return h(
      ComponentMap[context.props.type],
      { ...context.data, props: context.props },
      context.children
    );
  },
};
